import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mp-footer',
  templateUrl: './mp-footer.component.html',
  styleUrls: ['./mp-footer.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MpFooterComponent {}
